import moment from "moment/moment";
/*
The datepicker needs to work with Dates. They will be used to 
fetch resources filtered by UTC date. However, the datepicker 
we use treats dates in local time. We are only interested in 
the start of the day, so we need to convert in and out 
between UTC moments and local Dates.
*/

export const utcMomentToLocalDate = m =>
  new Date(m.year(), m.month(), m.date());

export const localDateToUtcMoment = d =>
  moment.utc([d.getFullYear(), d.getMonth(), d.getDate()]);



// WEBPACK FOOTER //
// ./src/helpers/dates.js